import styles from "./SectionPage.module.css";

const SectionPage = ({
  id,
  title,
  description,
  contentTitle, 
  children,
  reverse = false,
  className = "",
}) => {
  return (
    <section id={id} className={`${styles.section} ${className}`}>
      <div className={styles.container}>
        {(title || description) && (
          <header className={styles.header}>
            {title && <h2 className={styles.title}>{title}</h2>}

            {description && (
              <p className={styles.description}>
                {description}
                <span className={styles.descriptionLogo} />
              </p>
            )}
          </header>
        )}


        {contentTitle && (
          <h2 className={styles.contentTitle}>{contentTitle}</h2>
        )}

        <div
          className={`${styles.content} ${
            reverse ? styles.contentReverse : ""
          }`}
        >
          {children}
        </div>
      </div>
    </section>
  );
};

export default SectionPage;
